import React from 'react';
import Grid from '@mui/material/Grid2';

import { 
  CampaignObject,
  CharacterItem,
  CharacterSpell,
  DandDFeatureSource,
  PseudoItem,
  SummonOption2,
} from "@dndModels";
import { ModelBase, PlayerObject } from "@models";

import DandDAPI from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import { makeStyles } from "@utilities/theme_utilities";

import DisplayObject from "@dndComponents/display/DisplayObject";
import DeleteButton from '@components/input/buttons/DeleteButton';

interface Props {
  obj: ModelBase | PlayerObject | CampaignObject | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem;
  getName?: (obj: ModelBase | PlayerObject | CampaignObject | CharacterSpell | CharacterItem | SummonOption2 | PseudoItem) => string;
  onSelect: () => void;
  onDelete: () => void;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function ListOptionsRow({
  obj,
  getName,
  onSelect,
  onDelete
}: Props) {
  // const [reloading, setReloading] = useState(false);

  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);
  
  const useStyles = makeStyles()((theme) => {
    if (obj instanceof DandDFeatureSource) {
      const colors = char_util.getColors({ user: api.user, for_id: obj._id, source: obj });
      return ({
        root: {
          backgroundColor: colors.backgroundColor,
          // border: "1px solid #777777",
          color: colors.color,
          // padding: "4px",
          // margin: "4px",
          // '&:hover': {
          //   backgroundColor: "Black",
          //   color: theme.palette.secondary.light
          // },
        }
      });
    } else {
      // console.log(theme);
      return ({
        root: {
          backgroundColor: theme.palette.secondary.main
        },
      });
    }
  });

  const { classes, cx } = useStyles();
  
  return (
    <Grid container spacing={0} direction="row" className={cx(classes.root)}>
      <Grid size={10} className="clickable padded" onClick={() => { onSelect(); }}>
        { getName ? getName(obj) : <DisplayObject obj={obj} display_variant /> }
      </Grid>
      <Grid size={2}>
        <DeleteButton
          onClick={onDelete}
        />
      </Grid>
    </Grid>
  );
}
